import pick from 'lodash/pick';

import type { RxDBInstance } from '../../../types/database';
import { isBookwise, isExtension, isTest } from '../../../utils/environment';
import logger from '../logger';
import documents from './documents';
import global_tags from './global_tags';
import goodreads_imports from './goodreads_imports';
import state_syncing_key_value_pairs from './state_syncing_key_value_pairs';
import state_syncing_updates from './state_syncing_updates';
import tracked_books from './tracked_books';

// If you're updating this, also update the DatabaseCollectionNamesToDocType type
export const schema = {
  ...documents.getSchema(),
  ...global_tags.getSchema(),
  ...state_syncing_key_value_pairs.getSchema(),
  ...state_syncing_updates.getSchema(),
  ...isBookwise || isTest ? tracked_books.getSchema() : {},
  ...isBookwise || isTest ? goodreads_imports.getSchema() : {},
};


export default async function defineSchema(database: RxDBInstance, isInForeground?: boolean) {
  const collections = isExtension && isInForeground ? pick(schema, ['documents', 'global_tags']) : schema;
  const collectionVersions = Object.fromEntries(
    Object.entries(collections).map(([name, config]) => [name, (config as { schema: { version: number; }; }).schema.version]),
  );
  logger.debug('Defining schema, collections and versions:', collectionVersions);
  await database.addCollections(collections);
  logger.debug('Schema created');
}
